exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-blog-jsx": () => import("./../../../src/pages/blog.jsx" /* webpackChunkName: "component---src-pages-blog-jsx" */),
  "component---src-pages-exchange-tsx": () => import("./../../../src/pages/exchange.tsx" /* webpackChunkName: "component---src-pages-exchange-tsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-posts-post-template-jsx": () => import("./../../../src/posts/postTemplate.jsx" /* webpackChunkName: "component---src-posts-post-template-jsx" */)
}

